import { useBlockProps, InnerBlocks, RichText } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const { linkUrl,
          linkText,
          ariaLabel,
          sizeSlug
         } = attributes;

  const blockProps = useBlockProps.save();

  return (
    <div {...blockProps}>
      <div className="col">
        <div className="card">
            <InnerBlocks.Content />
          <div className="card-img-overlay">
              <a href={linkUrl}
                 aria-label={ariaLabel ? ariaLabel : undefined}
                className="btn btn-link">

                {linkText}
              </a>
          </div>
        </div>
      </div>
    </div>
  );
}
